// ===== Irontools: frontend bundle entry =====
import '../css/app.css';

// Bootstrap JS (dropdowns, offcanvas, collapses)
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Persistent modules
import initHeader from './modules/header';
import initNavIndicator from './modules/nav-indicator';
import initFontAwesome from './modules/fontawesome';

// Page-scoped modules
import initFaq from './modules/faq';
import initVisionNav from './modules/vision-nav';

// Router
import initBarba from './modules/barba-router';

function mountPage(root = document) {
    initFaq(root);
    initVisionNav(root);
}

function bootstrap() {
    // FA needs to register icons + start the mutation observer BEFORE
    // page modules mount, so any <i> tags they inject get processed.
    initFontAwesome();

    initHeader();
    initNavIndicator();

    initBarba({ mountPage });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
} else {
    bootstrap();
}
